import {
  DTDistributionNode,
  DTNode,
  WeightedNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {trimDescription} from './trimDescription';

export function serializeDistributionNode(node: DTNode, newNode: ServerNode) {
  const distributionNode = node as DTDistributionNode;

  return {
    ...newNode,
    description: trimDescription(newNode.description),
    outputs: (distributionNode.outputs as WeightedNodeOutputData[]).map((output) => {
      return {nodeId: output.nodeId, weight: output.weight, id: output.id, name: output.name};
    }),
  };
}

